import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NavController } from '@ionic/angular/standalone';
import { StateService } from 'src/app/services/state.service';
import { Subscription } from 'rxjs';
import { Subscriptions } from '@chemist2u/types-client/C2U/ParseObjects';
import { ProgramCardComponent } from "../program-card/program-card.component";

@Component({
    selector: 'app-program-wrapper',
    templateUrl: './program-wrapper.component.html',
    styleUrls: ['./program-wrapper.component.scss'],
    imports: [ProgramCardComponent]
})
export class ProgramWrapperComponent implements OnInit, OnDestroy {
  private $state = inject(StateService);
  private navController = inject(NavController);
  
  public subscriptions = signal<Subscriptions[]>([]);
  public activeSubscriptions = signal<Subscriptions[]>([])

  private subscriptionsSub?: Subscription;

  ngOnInit() {
    this.subscriptionsSub = this.$state.bSubscriptions.subscribe(subs => {
      this.subscriptions.set(subs);
      this.setActiveOrders();
    })
  }

  ngOnDestroy() {
    this.subscriptionsSub?.unsubscribe();
  }

  setActiveOrders() {
    const activeSubscriptions = this.subscriptions().filter(s => s.status == "Active");
    this.activeSubscriptions.set(activeSubscriptions);
  }

  goToProgram(subscription: Subscriptions) {
    this.navController.navigateForward(`/program/${subscription.id}`, { queryParams: { returnURL: '/tabs/home' }, state: { subscription }});
  }

}